import { ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

export const Jfind1384PageHeading = () => {
    return (
        <h1 css={headingCss}>
            <FormattedMessage
                id="jfind1384PageHeading"
                defaultMessage="Start with Jira - <span>No credit card</span> needed"
                values={{
                    span: HighlightText
                }}
            />
        </h1>
    );
};

const HighlightText = (children: ReactNode) => (
    <span css={hightlightCss}>{children}</span>
);

const headingCss = css({
    fontWeight: 700,
    lineHeight: 1.6,
    textAlign: "center",
    margin: 0,
    [media.above.sm]: {
        fontSize: 48
    },
    [media.only.sm]: {
        fontSize: 44
    },
    [media.below.xs]: {
        fontSize: 40
    }
});

const hightlightCss = css({
    backgroundColor: "transparent",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='305' height='79' fill='none'%3E%3Cpath fill='%23CFE1FD' d='M.902 12.027 302.245.527l2.543 66.655-301.342 11.5z'/%3E%3C/svg%3E")`,
    backgroundSize: "100% 100%",
    margin: -5,
    padding: 5
});
